/** @format */

import {styled} from '@mui/material/styles';
import {Table, TableCell, TableRow} from '@mui/material';

export const StyledTable = styled(Table)(() => ({
  tableLayout: 'fixed',
  width: '100%',
}));

const PREFIX = 'TableRow';

export const tableRowClasses = {
  styledButton: `${PREFIX}-styledButton`,
};

export const StyledTableRow = styled(TableRow)(({theme}) => ({
  '&:hover': {
    background: '#202020',
  },

  '.MuiTableCell-root:not(:nth-last-of-type(1))': {
    borderRight: `1px solid ${theme.palette.background.default}`,
  },

  '.MuiTableCell-root:nth-of-type(1)': {
    borderRadius: theme.spacing(2, 0, 0, 2),
  },

  '.MuiTableCell-root:nth-last-of-type(1)': {
    borderRadius: theme.spacing(0, 2, 2, 0),
  },

  [`.${tableRowClasses.styledButton}`]: {
    height: '100%',
    width: '100%',
    boxSizing: 'content-box',
    padding: 0,
    borderRadius: 0,
    transition: '0.2s',

    color: '#3d3d3d',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '16px',

    '&:hover': {
      color: theme.palette.figma_gray_light_1?.main,
      background: theme.palette.figma_gray_dark_2?.main,
    },
  },
}));

export const StyledTableCell = styled(TableCell)(({theme}) => ({
  width: '100%',
  height: '48px',
  padding: theme.spacing(0, 4),
  border: 'none',

  color: theme.palette.figma_gray_light_1?.main,
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '20px',
}));

export const ButtonCell = styled(StyledTableCell)(() => ({
  width: '80px',
  padding: 0,
}));
